angular.module('app.constants', [])
.constant('version', '1.32.1')
.constant('customerName', 'fbr');



// WEBPACK FOOTER //
// ./.tmp/components/common/constants/ngConstants.js